import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import KciApi from '../../common/api/KCI';
import { getQuote } from './QuoteSlice';

function PaymentBlock() {
  const quoteData = useSelector(getQuote);
  const { getValues } = useFormContext();
  const [paymentInfo, setPaymentInfo] = useState<any>();

  const watchFieldArray = useWatch({ name: 'quote' });
  const watchPaymentType = watchFieldArray.find(
    (quote: any) => quote.formId === 'payment_paytype',
  );

  useEffect(() => {
    KciApi.getPriceUpdate(watchPaymentType.value || 'lump-sum').then((data) => {
      setPaymentInfo(data.data);
    });
  }, [watchPaymentType.value]);
  return (
    <>
      {paymentInfo
           && (
           <div className="p-3 price-breakdown mb-4">
             <div className="d-flex justify-content-between mb-2">
               <span className="">
                 Policy
               </span>
               <strong className="">
                 {paymentInfo.policy}
               </strong>
             </div>
             <div className="d-flex justify-content-between mb-2">
               <span className="">
                 Premium (
                 {paymentInfo.ipt_vat_text}
                 )
               </span>
               <strong className="">
                 {paymentInfo.premium}
               </strong>
             </div>
             <div className="d-flex justify-content-between mb-2">
               <span className="">
                 Transaction Fee
               </span>
               <strong
                 className=""
                 dangerouslySetInnerHTML={
                {
                  __html: (paymentInfo.service_charge_prefix
                + (paymentInfo.service_charge_prefix
                  ? paymentInfo.service_charge_formatted : paymentInfo.service_charge)
                + paymentInfo.service_charge_suffix),
                }
}
               />
             </div>
             <div className="d-flex justify-content-between mb-2">
               <span className="">
                 Total Payable
               </span>
               <strong className="">
                 {paymentInfo.total_payable}
               </strong>
             </div>
           </div>
           )}
      <div />
    </>
  );
}
export default PaymentBlock;
